import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227","key":"svg-0"}]]

/**
 * IconFilter
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZmlsdGVyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDRoMTZ2Mi4xNzJhMiAyIDAgMCAxIC0uNTg2IDEuNDE0bC00LjQxNCA0LjQxNHY3bC02IDJ2LTguNWwtNC40OCAtNC45MjhhMiAyIDAgMCAxIC0uNTIgLTEuMzQ1di0yLjIyNyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/filter
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconFilter = createReactComponent('outline', 'filter', 'Filter', __iconNode);

export default IconFilter;